module.exports = __webpack_public_path__ + "img/dispatched_orders.0c193e5e.svg";